import React from 'react';
import '../styles/Education.css';

function Education() {
  const educationHistory = [
    {
      id: 1,
      institution: 'Chaitanya Bharathi Institute of Technology',
      degree: 'M.Tech',
      fieldOfStudy: 'Computer Science',
      duration: '2020 - 2022',
      location: 'Hyderabad, India',
      grade: '8.9 GPA'
    },
    {
      id: 2,
      institution: 'Vaagdevi College of Engineering',
      degree: 'B.Tech',
      fieldOfStudy: 'Computer Science Engineering',
      duration: '2014 - 2018',
      location: 'Warangal, India',
      grade: '64%',
    },
    {
      id: 3,
      institution: 'Sri CV Raman Junior College',
      degree: 'Intermediate',
      duration: '2012 - 2014',
      location: 'Telangana, India',
      grade: '75%',
    },
    {
      id: 4,
      institution: 'Telangana Social Welfare Jangoan',
      degree: 'SSC',
      duration: '2012',
      location: 'Telangana, India',
      grade: '8.3 GPA',
    }
  ];

  return (
    <div className="education-section">
      <h2>Education</h2>
      {educationHistory.map((edu) => (
        <div key={edu.id} className="education-entry">
          <h3>{edu.institution}</h3>
          <p>{edu.degree} - {edu.fieldOfStudy}</p>
          <p>{edu.duration}</p>
          <p>{edu.location}</p>
          {edu.grade && <p>Grade: {edu.grade}</p>}
        </div>
      ))}
    </div>
  );
}

export default Education;
